import { render, staticRenderFns } from "./privateMessage.vue?vue&type=template&id=5aa87e52&"
import script from "./privateMessage.vue?vue&type=script&lang=js&"
export * from "./privateMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports